import { useMemo } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'

import { resolveEffectiveBranding } from '../../../../branding'
import { QueryKeys } from '../../../../constants/queryKeys.constants'
import { ConfigurationCategory } from '../../types/configuration.types'
import { getBrandingConfiguration, updateBrandingConfiguration } from '../../services/configuration.service'

import type { BrandingConfigurationType } from '../../../../branding/types'

export const useBrandingConfiguration = () => {
  const queryClient = useQueryClient()

  const { data: configuration, isLoading } = useQuery({
    queryKey: [QueryKeys.CONFIGURATION, ConfigurationCategory.BRANDING],
    queryFn: getBrandingConfiguration,
  })

  const effective = useMemo(() => resolveEffectiveBranding(configuration), [configuration])

  const update = async (data: Partial<BrandingConfigurationType>) => {
    await updateBrandingConfiguration(data)
    await queryClient.invalidateQueries({ queryKey: [QueryKeys.CONFIGURATION, ConfigurationCategory.BRANDING] })
  }

  return {
    configuration,
    effective,
    isLoading,
    update,
  }
}
